<ng-container *ngIf="tableData && chartData; else noData">
	<ng-container *ngIf="showHeader">
		<div class="title-icon">
			<span class="text-uppercase text-18-bold" dcrHTMLKey="ESG_RATING_DISTRIB_LABEL" data-cy="esg-rating-distrib-title">ESG Rating Distribution</span>
			<icon type="info-circle" class="info-circle" tooltip-dcr="ESG_RATING_DISTRIB_LABEL_TOOLTIP" [analytic-data]="{ linkName: 'ESG_RATING_DISTRIB_LABEL_TOOLTIP' }"></icon>
		</div>
		<div class="margin-vertical-10 text-16" dcrHTMLKey="ESG_RATING_DISTRIB_DESCRIPTION" data-cy="esg-rating-distrib-subtitle">ESG_RATING_DISTRIB_DESCRIPTION</div>
	</ng-container>
	<dl-chart-table
		data-cy="esg-rating-distrib-chart-table"
		[tableDataTab]="tableData"
		[chartDataTabs]="chartData"
		[chartConfig]="chartConfig"
		[portfolioCount]="portfolioCount"
		[colors]="PORTFOLIO_COLORS"
		[showLegendTableInToggleMode]="false"
		[toggleBreakpoint]="3"
		[alignChartWithTable]="true"
	></dl-chart-table>
	<ng-container *ngIf="showNoRatingHoldingsComponent">
		<ng-container *componentId="'esg.noRating.holdings'; let res">
			<esg-no-rating-holdings [data]="res"> </esg-no-rating-holdings>
		</ng-container>
	</ng-container>
	<ac-disclosure [isExpandable]="false" dcrKey="ESG_RATING_DISTRIB_DISCLOSURE"></ac-disclosure>
	<ac-disclosure [isExpandable]="false" *ngIf="showAsOfDateDynamic && asOfDate">
		<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ asOfDate: asOfDate }">As of asOfDate</span>
	</ac-disclosure>
</ng-container>
<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
